module.exports = __webpack_public_path__ + "static/media/segoeui-light.fe64866d.woff2";